import { forwardRef, createElement } from 'react';

function IconCircleClose(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM8.641 8.641a.75.75 0 01.984-.067l.077.067L12 10.94l2.298-2.298a.75.75 0 011.128.984l-.067.077L13.06 12l2.298 2.298a.75.75 0 01-.984 1.128l-.077-.067L12 13.06l-2.298 2.298a.75.75 0 01-1.128-.984l.067-.077L10.94 12 8.641 9.702a.75.75 0 010-1.06z"
  }));
}

var CircleClose = /*#__PURE__*/forwardRef(IconCircleClose);

export default CircleClose;
//# sourceMappingURL=CircleClose.js.map
